module.exports = __webpack_public_path__ + "static/04-fe8ce707eb6708bfb300143954582064.jpg";